export interface AddressPostal {
  municipality: string;
  postalCode: string;
  addressLines: string[];
  regions: string;
  countryCode: string;
}

export class AddressPostalAdapter {
  constructor(public source?: Partial<AddressPostal>) {}

  get city(): string {
    return !!this.source && this.source.municipality;
  }
  get country(): string {
    return !!this.source && this.source.countryCode;
  }
  get state(): string {
    return !!this.source && !!this.source.regions && this.source.regions[0];
  }
  get streetAddress(): string {
    return (
      !!this.source && !!this.source.addressLines && this.source.addressLines[0]
    );
  }
  get zipCode(): string {
    return !!this.source && this.source.postalCode;
  }
}
